import { createApp } from 'vue'
import App from './App.vue'
import 'bootstrap'
import 'bootstrap/dist/css/bootstrap.min.css'
import "@/_ref_libvue/css/modal.css";
import router from './router'

import "../src/assets/css/app.css"
import "@/_ref_libvue/css/tooltip.css";
import "../../wwwroot/css/util.css"
import "../../wwwroot/css/button.css"
import "../../wwwroot/css/Account.css";
import "../../wwwroot/css/fonts/icons.css"
import "../../wwwroot/css/fonts/iconfont.css"
import "../../wwwroot/css/text.css"
import 'vue3-date-time-picker/dist/main.css'

createApp(App).use(router).mount('#app')
